import cn from '@/utils/cn';
import React, { HTMLAttributes, ReactNode } from 'react';
import { VariantProps } from 'class-variance-authority';
import { cardVariants } from './cardVariants';

interface CardProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof cardVariants> {
  children: ReactNode;
}

const Card: React.FC<CardProps> = ({ children, variant, className, ...props }) => {
  return (
    <div className={cn(cardVariants({ variant, className }))} {...props}>
      {children}
    </div>
  );
};

export default Card;
